import { htmlToText } from "../../../utils/htmlToText";
import { toast } from "react-toastify";


export async function SupplierCard_importAliexpressText(
  adId: string,
  aliexpressData: any,
  updateAd: (data: any) => void
) {
  const titleObj: Record<string, string> = {};
  const descriptionObj: Record<string, string> = {};
  Object.entries(aliexpressData).forEach(([country, obj]: any) => {
    if (obj && obj.success) {
      const div = document.createElement('div')
      div.innerHTML = obj.data.ae_item_base_info_dto.detail
      div.style.opacity = '0';
      document.body.appendChild(div)
      const descriptionText = htmlToText(div)
      document.body.removeChild(div)
      titleObj[country] = obj.data.ae_item_base_info_dto.subject
      descriptionObj[country] = descriptionText
    }
  })
  

  updateAd({
    title: titleObj,
    description: descriptionObj,
  })
  toast.success('Titre & description importés avec succès')
}

